var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID",
    width: 16.875,
    height: 18.75,
    fill: "none",
    stroke: "#6c5b7b",
    strokeWidth: 0.8
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Invoice"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invoice",
    clipPath: "url(#clip-Invoice)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3736",
    "data-name": "Group 3736",
    transform: "translate(-672.639 -358.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3735",
    "data-name": "Group 3735",
    transform: "translate(671.639 358.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3734",
    "data-name": "Group 3734",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6006",
    "data-name": "Path 6006",
    d: "M716.857,367.139v1.811a.311.311,0,0,0,.31.309h.125a.309.309,0,0,0,.307-.27l0-.039a1.085,1.085,0,0,1,2.156,0l0,.039a.31.31,0,0,0,.618-.04v-1.811a.24.24,0,0,0-.239-.239H717.1a.24.24,0,0,0-.245.235Z",
    transform: "translate(-710.262 -365.607)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6008",
    "data-name": "Path 6008",
    d: "M723.322,408.7a.27.27,0,0,0-.187-.22l-.435-.094a.637.637,0,0,1-1.031,0l-.435.094a.271.271,0,0,0-.188.22l-.094.452h2.476Z",
    transform: "translate(-713.759 -401.044)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6009",
    "data-name": "Path 6009",
    d: "M726.69,400.215a.55.55,0,1,1-.548-.595.573.573,0,0,1,.548.595",
    transform: "translate(-717.722 -393.555)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_689",
    "data-name": "Rectangle 689",
    width: 3.397,
    height: 3.397,
    transform: "translate(6.721 5.141)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6010",
    "data-name": "Path 6010",
    d: "M703.577,426.789h7.7",
    transform: "translate(-698.919 -416.762)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_654",
    "data-name": "Line 654",
    x2: 7.697,
    transform: "translate(4.658 11.514)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6005",
    "data-name": "Path 6005",
    d: "M725.188,361.727v-.052a.86.86,0,0,0-1.718,0v.052",
    transform: "translate(-715.91 -360.435)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6007",
    "data-name": "Path 6007",
    d: "M748.465,382.332V372.142a.281.281,0,0,0-.281-.281H745.5",
    transform: "translate(-63.091 -11.804)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6007-2",
    "data-name": "Path 6007",
    d: "M695.719,371.861h-2.555a.281.281,0,0,0-.281.281h0v13.969a.281.281,0,0,0,.281.281h7.484",
    transform: "translate(-18.144 -11.804)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 3.047,
    cy: 3.047,
    r: 3.047,
    transform: "translate(682.331 370.528)",
    fill: "none",
    stroke: "#6c5b7b",
    strokeMiterlimit: 10,
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6005-2",
    "data-name": "Path 6005",
    d: "M759.816,456.39h-.532a1.049,1.049,0,0,0-.42-.733h.952a.1.1,0,1,0,0-.209H757.6a.1.1,0,0,0,0,.209h.634a.846.846,0,0,1,.839.733H757.6a.1.1,0,0,0,0,.209h1.473a.847.847,0,0,1-.839.743H757.6a.107.107,0,0,0-.1.108.109.109,0,0,0,.033.075l1.584,1.5a.1.1,0,0,0,.148,0,.106.106,0,0,0,0-.15l-1.394-1.318h.371a1.058,1.058,0,0,0,1.05-.953h.532a.1.1,0,1,0,0-.209Z",
    transform: "translate(-73.334 -83.199)",
    fill: "#6c5b7b",
    stroke: "#6c5b7b",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllInvoice);
export default __webpack_public_path__ + "static/media/all-invoice.bb7f21db7d516e42f7c93971aa5c163d.svg";
export { ForwardRef as ReactComponent };